import styled from "styled-components";

const StationProfile = styled.div`
    background-color: #FCFDFF;
    border: 1px solid lightgray;
    box-sizing: border-box;
    border-radius: 5px;
    padding: 10px;
    & > .container{
        & > .row{
            display: flex;
            justify-content: center;
            
            & > *{
                width: 50%;
            }

            &.parameter{
                border: 1px solid lightgray;
                text-align: center;
            }
        }
    }
`

export default function Index(props) {
    const getStationStatus = (code) =>{
        if(code == 0){ return <div style={{color: '#3D3D3D', fontWeight: "bold"}}>ปิดใช้งาน</div>
          }else if(code == 1){ return <div style={{color: '#85e700', fontWeight: "bold"}}>เปิดใช้งาน</div>
          }else{ return <div style={{color: '#FFD02B', fontWeight: "bold"}}>ไม่พบสถานะ</div>}
    }
    return (
        <StationProfile className={"card-station-profile" + (props.className ? props.className : "")}>
            <div className="container">
               <div className="row"><div className="k">สถานะ</div><div className="v">{getStationStatus(props.status)}</div></div>
               <div className="row"><div className="k">ชื่อสถานี</div><div className="v">{props.disp_name ? props.disp_name:  "-"}</div></div>
               <div className="row"><div className="k">จังหวัดที่ตั้ง</div><div className="v">{props.province ? props.province:  "-"}</div></div>
               <div className="row"><div className="k">ผู้ดูแลสถานี</div><div className="v">{props.contact_person ? props.contact_person:  "-"}</div></div>
               <div className="row"><div className="k">แลตติจูด</div><div className="v">{props.gps_lat ? props.gps_lat:  "-"}</div></div>
               <div className="row"><div className="k">ลองติจูด</div><div className="v">{props.gps_long ? props.gps_long:  "-"}</div></div>
               <div className="row"><div className="k">จำนวนเซนเซอร์วัดระดับน้ำ</div><div className="v">{props.sensors.length}</div></div>
               <div className="row"><div className="k">หมายเหตุ</div><div className="v">{props.description ? props.description : '-'}</div></div>
            </div>
        </StationProfile>
    )
}
